import { FunctionComponent, lazy, Suspense } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import axios from 'axios';

import { ThemeContext, useCustomTheme } from './theme';
import Loader from './components/Loader';

const LoginPage = lazy(() => import('./pages/LoginPage'));
const MainApp = lazy(() => import('./pages/MainApp'));

import { AppContextProvider } from './context/authContext';
import { API_URL, BASE_NAME_FRONTEND } from './utils/apiRoutes';

const App: FunctionComponent = () => {
  const [theme] = useCustomTheme();
  axios.defaults.baseURL = API_URL;
  axios.defaults.headers.post['Content-Type'] = 'application/json';

  return (
    <AppContextProvider>
      <ThemeContext.Provider value={theme}>
        <Router basename={BASE_NAME_FRONTEND}>
          <Suspense fallback={<Loader />}>
            <Switch>
              <Route path="/login" component={LoginPage} />
              <Route path="/" component={MainApp} />
            </Switch>
          </Suspense>
        </Router>
      </ThemeContext.Provider>
    </AppContextProvider>
  );
};

export default App;
